import React from "react";
import { MoneyFormat, upperCase, useWindowsSize } from "../../libs";

function CardService({ props }) {
  const { layanan } = props;
  const size = useWindowsSize();
  return (
    <div className="card-service cursor-pointer bg-white flex items-center justify-between w-full p-3 lg:p-5 lg:w-11/12">
      <div>
        {size.width <= 640 && (
          <div className="w-full h-32 mb-5">
            <img
              className="rounded-xl object-cover w-full h-32"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/assets/image/img_empty.png"; // some replacement image
              }}
              src={
                process.env.REACT_APP_BACKEND_URL + "/storage/" + layanan.image
              }
              alt="img-hospital"
            />
          </div>
        )}
        <p className="header-title-semi  m-0 text-sm lg:text-base font-semibold colors-blue leading-5 lg:leading-none">
          {upperCase(
            layanan?.name ?? "PCR Swab Test (Drive Thru) - Hasil 1 Hari Kerja"
          )}
        </p>
        <p className="header-content m-0 mt-2 lg:mt-1 font-semibold text-xs lg:text-base colors-orange">
          {layanan
            ? layanan["total_harga"]
              ? "Rp. " + MoneyFormat(Number(layanan.total_harga))
              : layanan["harga"]
              ? "Rp. " + MoneyFormat(Number(layanan.harga))
              : "Rp. 1.400.000"
            : "Rp. 1.400.000"}
        </p>
        <div className="flex items-baseline lg:items-center mt-4 lg:mt-3">
          <img
            className="mr-2 h-3 lg:h-3.5 w-auto"
            src={
              process.env.REACT_APP_BASE_URL + "/assets/icon/ic_hospital.svg"
            }
            alt="icon-hospital"
          />
          <p className="header-content m-0 text-xs lg:text-sm colors-gray font-semibold">
            Balai Besar Laboratorium Kesehatan
          </p>
        </div>
        <div className="flex items-baseline lg:items-center mt-2 lg:mt-0">
          <img
            className="mr-2 h-3 lg:h-3.5 w-auto"
            src={
              process.env.REACT_APP_BASE_URL + "/assets/icon/ic_location.svg"
            }
            alt="icon-location"
          />
          <p className="header-content m-0 text-xs lg:text-sm colors-gray">
            Gubeng, Kota Surabaya
          </p>
        </div>
      </div>
      {size.width > 640 && (
        <div className="w-48 h-32  lg:-mr-20">
          <img
            className="rounded-2xl object-cover w-48 h-32"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/assets/image/img_empty.png"; // some replacement image
            }}
            src={
              process.env.REACT_APP_BACKEND_URL + "/storage/" + layanan.image
            }
            alt="img-hospital"
          />
        </div>
      )}
    </div>
  );
}

export default CardService;
